import React from 'react';
import Svg, {SvgProps, Circle} from 'react-native-svg';

const ApplicationStepperCircle = (props: SvgProps) => {
    return (
        <Svg width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
            <Circle cx="10" cy="10" r="9.5" fill="#F2F2F2" stroke="#999999" />
        </Svg>
    );
};

export default ApplicationStepperCircle;
